import {
  SMART_CONTRACT_WALLET_APP_ID,
  SMART_CONTRACT_WALLET_DEV_APP_ID,
} from '@onramp/constants/cbWallets';
import { isDevelopment } from '@onramp/utils/environment/sharedEnv';

export const isSmartContractWalletApp = (appId: string) => {
  if (appId === SMART_CONTRACT_WALLET_APP_ID) {
    return true;
  }

  return isDevelopment && appId === SMART_CONTRACT_WALLET_DEV_APP_ID;
};
